export const flattenObject : any = (obj:any, roots:string[] = [], sep = '.') => Object
  .keys(obj)
  .reduce((memo, prop) => Object.assign(
    {},
    memo,
    Object.prototype.toString.call(obj[prop]) === '[object Object]'
      ? flattenObject(obj[prop], roots.concat([prop]), sep)
      : {[roots.concat([prop]).join(sep)]: obj[prop]}
  ), {})